import EventSearch from './EventSearch';

export default EventSearch;
